import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Consent.css";

function Consent() {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const location = useLocation();
  const prevPage = location.state?.from || "login";

  const handleNext = () => {
    if (prevPage === "dashboard") {
      navigate(`/quiz`, { state: { type: "firstquiz" } });
    } else {
      navigate(`/quiz`, { state: { type: "guest" } });
    }
  };

  function handleCheck(event) {
    setIsChecked(event.target.checked);
  }

  // handling the logout button
  const handleLogout = () => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.message);
        navigate(`/`);
      })
      .catch((error) => console.error("Error logging out:", error));
  };

  return (
    <div className="exp-statement-container">
      {prevPage !== "login" && (
        <header className="dash-header">
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          <button onClick={handleLogout}>Log Out</button>
        </header>
      )}
      <h1>Informed Consent</h1>
      <div className="scroll-box">
        <h3>Explanatory Statement</h3>
        <p>
          <b>Project ID:</b> 48981<br></br>
          <b>Project title:</b> Round 2 – Evaluation of a Software Engineering
          Empathy Scale Tool Prototype<br></br>
          <br></br>
          <b>Investigators</b>
          <br></br>
          Prof John Grundy, Faculty of Information Technology, Monash
          University, Australia,{" "}
          <a href="mailto:john.grundy@monash.edu">john.grundy@monash.edu</a>
          <br></br>
          <b>Student Investigator</b>
          <br></br>
          Hashini Gunatilake, Faculty of Information Technology, Monash
          University, Australia,{" "}
          <a href="mailto:hashini.gunatilake@monash.edu">
            hashini.gunatilake@monash.edu
          </a>
          <br></br>
          Riya Vyas, Faculty of Information Technology, Monash University,
          Australia,{" "}
          <a href="mailto:rvya0001@student.monash.edu">
            rvya0001@student.monash.edu
          </a>
          <br></br>
          Devan Fedhi, Faculty of Information Technology, Monash University,
          Australia,{" "}
          <a href="mailto:dfed0003@student.monash.edu">
            dfed0003@student.monash.edu
          </a>
          <br></br>
          Jeffrey Yan, Faculty of Information Technology, Monash University,
          Australia,{" "}
          <a href="mailto:jyan0160@student.monash.edu">
            jyan0160@student.monash.edu
          </a>
          <br></br>
          Trung Nguyen, Faculty of Information Technology, Monash University,
          Australia,{" "}
          <a href="mailto:tngu0341@student.monash.edu">
            tngu0341@student.monash.edu
          </a>
          <br></br>
          Shekah Alayadhi, Faculty of Information Technology, Monash University,
          Australia,{" "}
          <a href="mailto:sala0023@student.monash.edu">
            sala0023@student.monash.edu
          </a>
          <br></br>
          <br></br>
          You are invited to take part in a project that is aimed at evaluating
          a software engineering empathy scale and tool that will be used to
          determine the empathy levels of individuals within the software
          engineering field. Empathy is the ability to understand the
          perspectives and emotions of another person. It is a very important
          human aspect that has shown to allow software practitioners to build
          products that more effectively meet user needs. By taking part in this
          project, you will complete an empathy quiz on an online web tool and a
          feedback survey about your overall user experience using the web tool
          (usability of the tool). At the end of the quiz and survey, a
          numerical score as well as textual information about your current
          empathy levels will be provided. Please read this Explanatory
          Statement in full before deciding whether or not to participate in
          this research. If you would like further information regarding any
          aspect of this project, you are encouraged to contact the researchers
          via the email addresses listed above.<br></br>
          <br></br>
          <b>Why were you chosen for this research?</b>
          <br></br>
          You are invited to participate in this research as you are an
          individual who primarily studies or works in the software engineering
          field. You have been personally contacted via email invitation to
          participate in this research, or you may have seen our advertisement
          shared via LinkedIn, X (formerly known as Twitter), or you may have
          seen the FIT4002 unit wide email asking for participants to complete
          our quiz and contacted us expressing your interest to participate in
          our study. As a software practitioner and SE student, we believe you
          can provide valuable insights on this topic.{" "}
          <b>
            Please note that Indonesian participants are not eligible to
            participate in this study due to ethics restrictions.
          </b>
          <br></br>
          <br></br>
          <b>What does the research involve?</b>
          <br></br>
          In this study we aim to evaluate the usability of our web-based
          empathy tool. We are collecting data directly using our web-based tool
          which consists of an online survey.<br></br>
          The online survey contains demographic questions, an empathy quiz, and
          some follow-up questions at the end of the empathy quiz. You will
          receive an email with a link to our web-based tool. In this tool, you
          can either create an account by providing your email address and
          demographic information before taking the survey or proceed without
          creating an account. If you create an account, we will use the
          demographic information you provide, so you will not need to answer
          those questions again in the survey. However, if you choose not to
          create an account, you will be asked to provide demographic
          information before starting the empathy quiz.<br></br>
          The empathy quiz serves as a measure of empathy and contains questions
          that require a self-evaluation of certain character statements by
          choosing an answer from ‘Does not describe me at all’ to ‘Completely
          describes me’.<br></br>
          After the completion of the quiz, there are few follow-up questions
          about the usability of the tool. This is done to get detailed feedback
          on your experience of taking the quiz and using our prototype tool so
          that improvements can be made accordingly.<br></br>
          Completing the survey should take approximately 20-30 minutes, and
          once the quiz is submitted, you will receive your empathy score as
          well as an empathy profile that explains how your score is
          interpreted. Your estimated overall time commitment is a maximum of 30
          minutes in total for the whole survey.<br></br>
          <br></br>
          <b>Consenting to participate in the project</b>
          <br></br>
          You have been invited to participate in this study from one of the
          ways mentioned above. As part of this, you have been provided with
          this Explanatory Statement. Please read it in full. If you agree to
          participate, use the provided link to access our tool. Before starting
          the survey in our web-based tool, you will be asked to provide your
          consent to take part in this study. To proceed with the quiz, you must
          read the consent statement in full and check the consent checkbox.
          <br></br>
          <br></br>
          <b>Withdrawing from the research</b>
          <br></br>
          You can withdraw your participation at any time up to 30 days after
          taking the survey by writing to the email addresses provided above.
          During the survey, you can withdraw your participation at any time by
          simply closing the empathy tool webpage. Further, all your data
          including survey responses will be deleted from the system if you
          decide to withdraw.<br></br>
          <br></br>
          <b>Possible benefits and risks to participants</b>
          <br></br>
          Your participation in this study is voluntary, and no reward is given
          for the participation.<br></br>
          However, by participating in this research, you will be able to obtain
          a score and text feedback that gives a baseline idea of your current
          overall empathy levels as well as where you stand in the different
          facets that make up empathy eg., cognitive, affective etc.<br></br>
          There are no known or anticipated risks to you as a participant in
          this research. Please note that you can opt out from this study at any
          time up to 30 days after the survey and that you do not have to answer
          any questions that you are not comfortable with.<br></br>
          <br></br>
          <b>Confidentiality</b>
          <br></br>
          Even though some personal data will be collected (e.g. your name,
          email address), all data will be processed, analysed and reported only
          in de-identified form. This will be done by allocating unique
          identifiers to your name and email address hence it will not be
          traceable back to you. Your personal information shall only be
          accessible by the investigators of this research. They will keep your
          identity confidential.<br></br>
          In general, all data collected during this research will be
          de-identified in storage where possible and processed in an anonymised
          fashion. Any potentially identifying material in the responses will be
          removed. Any papers published as a result of this research will not
          identify you and the responses you make will be published anonymously
          in these papers.<br></br>
          <br></br>
          <b>Storage, Retention, Destruction and Future Use of data</b>
          <br></br>
          Data collected through the empathy survey tool will be securely stored
          on a third-party database server (MongoDB). To ensure data security,
          the MongoDB server is equipped with industry-standard encryption
          protocols both in transit and at rest. Access to the server is
          restricted to the investigators of this study, with robust
          authentication mechanisms in place to ensure security. The website
          itself will be hosted on Netlify and Render. Netlify includes access
          control, secure deployment pipelines, and data encryption at rest and
          in transit, complying with privacy regulations and data protection
          laws. Render enforces HTTPS, uses trusted cloud providers (AWS and
          Google Cloud), applies strict access controls, automated backups, and
          follows industry-standard security and data protection practices to
          help ensure confidentiality.<br></br>
          At various phases of data collection, analysis, and reporting, the
          data will be securely downloaded to the investigators’ computers. All
          these systems and computers have access controls in place and cannot
          be accessed by unauthorised parties. All data will be destroyed after
          five years. This includes deleting data from both the MongoDB server
          and all local systems where it has been downloaded.<br></br>
          <br></br>
          <b>Use of data for other purposes</b>
          <br></br>
          The data collected during this study may be used for other related
          studies by the investigators within five years. In case of the data
          being reused, it will still be in an anonymised form.<br></br>
          <br></br>
          <b>Results</b>
          <br></br>
          The results of this study will be published in the thesis and final
          reports of the student investigators, peer reviewed academic
          conferences and/or journals and may be summarised at relevant industry
          workshops. A research report will also be available to participants
          upon request.<br></br>
          <br></br>
          <b>Complaints</b>
          <br></br>
          Should you have any concerns or complaints about the conduct of the
          research, you are welcome to contact the Executive Officer, Monash
          University Human Research Ethics Committee (MUHREC):<br></br>
          Executive Officer<br></br>
          Monash University Human Research Ethics Committee (MUHREC)<br></br>
          Room 111, Chancellery Building D,<br></br>
          26 Sports Walk, Clayton Campus<br></br>
          Research Office<br></br>
          Monash University VIC 3800<br></br>
          <br></br>
          Tel: +61 3 9905 2052 | Email: muhrec@monash.edu | Fax: +61 3 9905 3831
          <br></br>
          <br></br>
          Thank you,<br></br>
          ARC Laureate Professor John Grundy
        </p>
      </div>
      <p className="consent-container">
        By ticking the consent box below, you agree to take part in this study,
        and understand the following points that you have read in the
        explanatory statement above, you understand the purpose and method of
        the study and you will answer the survey.
        <ul>
          <li>I am not an Indonesian participant </li>
          <li>I am 18 years of age or older</li>
          <li>
            I have read the Explanatory Statement and have understood the nature
            of the research
          </li>
          <li>
            I understand that I am free to withdraw my participation at anytime
            while taking part in the research
          </li>
          <li>I agree to answer an online survey</li>
          <li>
            I consent to the collected data being stored in secure commercial
            servers (e.g. MongoDB)
          </li>
          <li>
            I understand that the data I provide during this research may be
            used by the investigators in future research project
          </li>
        </ul>
        Hereby, I certify that all the information above is correct. I
        understand that by clicking the "I consent" below is giving my consent
        to participate in this research study and this is equivalent to signing
        a consent form.
      </p>
      <div>
        <div className="consent-checkbox-row">
          <input
            type="checkbox"
            className="checkbox"
            onClick={handleCheck}
            id="consent-checkbox"
          />
          <b>I consent</b>
          <button
            className="next-btn"
            onClick={handleNext}
            disabled={!isChecked}
            style={{ marginLeft: "auto" }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default Consent;
